import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 6h5l7 10h6","key":"svg-0"}],["path",{"d":"M18 19l3 -3l-3 -3","key":"svg-1"}]]

/**
 * IconTrendingDown2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdHJlbmRpbmctZG93bi0yIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDZoNWw3IDEwaDYiIC8+CiAgPHBhdGggZD0iTTE4IDE5bDMgLTNsLTMgLTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/trending-down-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTrendingDown2 = createReactComponent('outline', 'trending-down-2', 'TrendingDown2', __iconNode);

export default IconTrendingDown2;